import {createRoot} from '@wordpress/element';
import Dashboard from './dashboard';

const root = document.getElementById('root');

if (root) {
    createRoot(root).render(
        <Dashboard data={wcStripeAdminSettings.dashboard}/>
    );
}

